export const enumPermisosCrediBanco = Object.freeze({
  CREDIBANCO_PAGO_DATAFONO: 80001,
  CREDIBANCO_REPORTE_TRANSACCIONES: 80002,
});

